import {
  ICollaboratorSchema,
  IMemberClient,
  IMemberClientForm1099Balances
} from "@wingspanhq/payments/dist/interfaces";

import DocumentMeta from "./DocumentMeta";

const getIsDraft = (data: IMemberClientForm1099Balances) =>
  !data.events?.submittedAt;

const getDocTitleSuffix = (data: IMemberClientForm1099Balances) =>
  getIsDraft(data) ? " draft" : "";

const getIsAcceptedByIrs = (data: IMemberClientForm1099Balances) =>
  Boolean(data.events?.acceptedByIrsAt);

const getDocAmount = ({
  platformIncome,
  adjustments,
  paymentProcessingFees
}: IMemberClientForm1099Balances) =>
  platformIncome + adjustments + paymentProcessingFees;

const getIsShared = (data: IMemberClientForm1099Balances) =>
  Boolean(data.events?.submittedForCollaboratorReviewAt);

export default function getDocumentsMetaFromProfile(
  profile: IMemberClient | ICollaboratorSchema
): DocumentMeta[] | null {
  const documentEntries =
    profile.form1099Balances &&
    (Object.entries(profile.form1099Balances) as [
      string,
      IMemberClientForm1099Balances
    ][]);
  if (!documentEntries || !documentEntries.length) return null;

  return documentEntries.map(([year, data]) => ({
    year,
    title: `1099-NEC${getDocTitleSuffix(data)}`,
    amount: getDocAmount(data),
    status: data.status,
    isDraft: getIsDraft(data),
    isShared: getIsShared(data),
    isAcceptedByIrs: getIsAcceptedByIrs(data)
  }));
}
